<script>
import NavBarPrimary from '@components/nav-bar/nav-bar-primary.vue';

export default {
  components: {
    NavBarPrimary,
  },
  computed: {
    isHeaderTransparent() {
      switch (this.$route.name) {
        case 'workoutDetail':
          return true;
        default:
          return false;
      }
    },
  },
};
</script>

<template>
  <div :class="$style.container">
    <NavBarPrimary :transparent="isHeaderTransparent" />
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  min-width: $size-content-width-min;
  overflow: hidden;
}
</style>
